module.exports = __webpack_public_path__ + "static/media/Hong Kong.e8efba6e.png";